define('dom',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.q = void 0;
    function q(selector) {
        return Array.from(document.querySelectorAll(selector));
    }
    exports.q = q;
});
//# sourceMappingURL=/assets/javascripts/dom.js.map;
